class LogoMarquee extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.styleButtons = this.querySelectorAll('.style-btn');
    this.marqueeContainer = this.querySelector('.logo-marquee-container');
    this.marquee = this.querySelector('.logo-marquee');
    
    if (this.styleButtons.length > 0 && this.marqueeContainer) {
      this.setupEventListeners();
    }
    
    this.setAnimationDuration();
    window.addEventListener('resize', this.debounce(() => this.setAnimationDuration(), 250));
  }

  setupEventListeners() {
    this.styleButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        this.handleStyleChange(e);
      });
    });
  }

  handleStyleChange(event) {
    const button = event.currentTarget;
    const style = button.getAttribute('data-style');
    
    // Remove active class from all buttons
    this.styleButtons.forEach(btn => btn.classList.remove('active'));
    // Add active class to clicked button
    button.classList.add('active');
    
    // Remove all style classes
    this.marqueeContainer.className = 'logo-marquee-container';
    // Add selected style class
    this.marqueeContainer.classList.add(`marquee-style-${style}`);
    
    // Reset animation
    this.resetAnimation();
  }

  setAnimationDuration() {
    if (!this.marquee) return;
    
    const marqueeWidth = this.marquee.scrollWidth / 2;
    const duration = Math.max(marqueeWidth / 50, 20);
    
    this.marquee.style.animationDuration = `${duration}s`;
  }

  resetAnimation() {
    if (!this.marquee) return;
    
    this.marquee.style.animation = 'none';
    setTimeout(() => {
      this.setAnimationDuration();
    }, 10);
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

customElements.define('logo-marquee-section', LogoMarquee);